export const ActionType_Order = 'order';
export const ActionSubTypes_Order = ['consult', 'poc', 'test', 'treatment'];
export const ActionType_Interflow = 'interflow';
export const ActionSubTypes_Interflow = ['h&p', 'restart', 'admit', 'discharge', 'activate-protocol', 'consider-protocol'];
//# sourceMappingURL=types.js.map